import { AxiosInstance } from 'axios';
import { AccountsReceivableSalesJournalReportRequestModel } from './models/AccountsReceivableSalesJournalReportRequestModel';
import * as AccountsReceivableSalesJournalReportService from './services';

export type AccountsReceivableSalesJournalReportServiceType = {
  exportPDF: (payload: AccountsReceivableSalesJournalReportRequestModel) => Promise<void>;
};

export const initAccountsReceivableSalesJournalReportService = (
  axios: AxiosInstance
): AccountsReceivableSalesJournalReportServiceType => ({
  exportPDF: payload => AccountsReceivableSalesJournalReportService.exportPDF(axios)(payload),
});
